import { ApiError } from '@cloudquery/custom-fetch';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import { getEnv } from 'shared/base';

import { Providers } from './components/utils/providers';
import { PageRoutes } from './routes';

const disableSentry = getEnv(
  'NEXT_PUBLIC_DISABLE_SENTRY',
  process.env.NEXT_PUBLIC_DISABLE_SENTRY,
  'false',
);

if (disableSentry !== 'true') {
  function processApiErrorForSentry(exception: unknown): boolean {
    if (exception instanceof ApiError) {
      const shouldReport = !exception._sentryReported;
      if (shouldReport) {
        exception._sentryReported = true;
      }

      return shouldReport;
    }

    return true;
  }

  Sentry.init({
    beforeSend(event, hint) {
      const shouldReport = processApiErrorForSentry(hint.originalException);
      if (
        !shouldReport ||
        (hint.originalException instanceof Error && hint.originalException.name === 'AbortError')
      ) {
        return null;
      }

      return event;
    },
    debug: false,
    dsn: process.env.NEXT_PUBLIC_PLATFORM_SENTRY_DSN,
    environment: process.env.SENTRY_ENV,
    normalizeDepth: 10,
    release: process.env.SENTRY_RELEASE,
    replaysOnErrorSampleRate: 1,
    replaysSessionSampleRate: 0,
    tracesSampleRate: 0,
  });
}

const root = document.querySelector('#root') as HTMLElement;

ReactDOM.createRoot(root).render(
  <Providers>
    <PageRoutes />
  </Providers>,
);
